
import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import rest from "@/rest";
import { namespace } from "vuex-class";
// components
import ExpandableCard from "../Shared/ExpandableCard.vue";
// interfaces
import { courseElementTypeItems } from "@/interfaces/Types";
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";
import { CourseElementType } from "@/interfaces/CourseElementType";
import { CustomizationVm } from "@/interfaces/CustomizationVm";
import { List } from "linq-collections";

const globals = namespace("globals");
const customization = namespace("customization");

@Component({
  components: {
    ExpandableCard,
  },
})
export default class MultipleChoiceElementSettings extends Vue {
  // @Prop() element!: CourseElementVm;

  @customization.Getter customizationSettings!: CustomizationVm;
  @globals.Getter selectedElement!: CourseElementVm | null;
  courseElementTypeItems = courseElementTypeItems;

  isBusy = false;

  mounted() {}

  onConvert() {
    if (!this.selectedElement) return;
    this.selectedElement.type = "SingleChoice";
  }

  get onlyOneSelection() {
    if (!this.selectedElement?.options) return false;

    let count = new List(this.selectedElement.options).count(o => o.isRight);

    if (count == 1) return true;

    return false;
  }

  getElementTitle(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.label : '';
  }

  getElementIcon(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.icon : '';
  }
}
